import type { Editor, JSONContent } from '@tiptap/core';
import type { Chatbot } from '@unriddle/db/types';

export const getPrevText = (
  editor: Editor,
  { chars, offset = 0 }: { chars: number; offset?: number },
) => {
  const text = editor.state.doc.textBetween(
    Math.max(0, editor.state.selection.from - chars),
    editor.state.selection.from - offset,
    '\n',
  );

  return text;
};

export function getLastParagraph(editor: Editor, chars: number) {
  const { doc, selection } = editor.state;
  const cursorPosition = selection.from;
  let text = '';

  // Get all previous paragraphs before cursor position
  doc.nodesBetween(0, cursorPosition, (node) => {
    if (node.type.name === 'paragraph') {
      text += `${node.textContent}\n`;
    }
  });
  const paragraphs = text.trim().split('\n').filter(Boolean);

  // Get the last paragraph and limit it to chars characters
  if (paragraphs.length > 0) {
    const lastParagraph = paragraphs[paragraphs.length - 1];

    if (!lastParagraph) return '';

    return lastParagraph.length > chars
      ? lastParagraph.slice(-chars)
      : lastParagraph;
  }

  return '';
}

export function shouldShowBubbleMenu(editor: Editor) {
  if (!editor) return false;

  const { from, to } = editor.state.selection;
  let shouldShow = true;

  editor.state.doc.nodesBetween(from, to, (node) => {
    if (node.type.name === 'horizontal_rule' || node.type.name === 'image') {
      shouldShow = false;
    }
  });

  return shouldShow;
}

export const backwardsCompatibilityContent = (
  chatbot?: Pick<Chatbot, 'contents' | 'name'> | null,
) => {
  if (!chatbot) return null;

  const content = chatbot?.contents as JSONContent | null;
  const title = chatbot?.name;

  const hasTitle = content?.content?.some((block) => block.type === 'title');

  if (hasTitle) return content;

  if (!content)
    return {
      type: 'doc',
      content: [
        {
          type: 'title',
          attrs: { level: 1 },
        },
        { type: 'paragraph' },
      ],
    };
  const contentWithTitle = {
    ...content,
    content: [
      {
        type: 'title',
        attrs: { level: 1 },
        content: [
          {
            type: 'text',
            text: title ?? '',
          },
        ],
      },
      ...(content?.content ?? []),
    ],
  } as JSONContent;

  return contentWithTitle;
};

import * as crypto from 'crypto';
export const md5 = (contents: string) =>
  crypto.createHash('md5').update(contents).digest('hex');
